/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getInfillAlterationOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { infillAlteration } from '../../../../entityModel';
import { ManageInfillAlterationsTableBody } from './ManageInfillAlterationsTableBody';
import { ManageInfillAlterationsTableHead } from './ManageInfillAlterationsTableHead';

interface ManageInfillAlterationsTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getInfillAlterationOutput;
  onEdit: (infillAlteration: infillAlteration) => void;
  onDelete: (infillAlteration: infillAlteration) => void;
}

export const ManageInfillAlterationsTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageInfillAlterationsTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageInfillAlterationsTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageInfillAlterationsTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
